export { default as createOneVoteMutation } from './create-one-vote-mutation';
